<template>
  <div class="form-wrapper">
    <div class="form-container">
      <form @submit.prevent="handleLogin">
        <h2>Iniciar Sesión</h2>
        <div class="form-group">
          <label for="username">Usuario</label>
          <input
            id="username"
            v-model="username"
            type="text"
            placeholder="Ingrese su usuario"
            required
          />
        </div>
        <div class="form-group">
          <label for="password">Contraseña</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="Ingrese su contraseña"
            required
          />
        </div>
        <button class="main_button" type="submit" :disabled="loading">
          {{ loading ? "Cargando..." : "Iniciar Sesión" }}
        </button>
        <p class="forgot-password">
          <router-link to="/forgot_password">He olvidado mi contraseña</router-link>
        </p>
      </form>
    </div>
    <img :src="logo" alt="Logo" class="logo" />
    <ErrorPopup :errorMessage="error" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from 'vue-router';
import { useLoadingStore } from "@/stores/loadingStore";
import ErrorPopup from "@/components/common/ErrorPopup.vue";

const username = ref("");
const password = ref("");
const error = ref(null);
const logo = require("@/assets/images/logo.png"); // Ruta de la imagen
const router = useRouter();
const loadingStore = useLoadingStore();

const handleLogin = async () => {
  loadingStore.setLoading(true);
  error.value = null;

  try {
    const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vdas": process.env.VUE_APP_API_VDAS,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
      },
      body: JSON.stringify({
        "user": username.value,
        "password": password.value,
      }),
    });

    if (!response.ok) {
      error.value = "Error en la autenticación";
    }

    const data = await response.json();

    if (data.errors) {
      error.value = data.message;
    } else {
      error.value = null;
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("token", data.user_token);
      router.push("/redeem");
    }
  } catch (exception) {
    error.value = exception.message;
  } finally {
    loadingStore.setLoading(false);
  }
};
</script>

<style scoped>

.logo {
  width: 100%;
  max-width: 450px;
  margin-top: 100px;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>
